import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { Ministry } from '../../../models/ministry.model';
import { StpRegistrationStorageService } from '../../../services/stp-registration-storage.service';

@Component({
  selector: 'app-ministry-list',
  templateUrl: './ministry-list.component.html',
  styleUrls: ['./ministry-list.component.scss']
})
export class MinistryListComponent implements OnInit {

  ministryForm!: FormGroup;

  total: number;
  size: number = 10;
  page: number = 1;
  sortingKey: string;
  sortingValue: string;

  listView : any;

  ministryList : Ministry = new Ministry();

  searchingForm: FormGroup = this.fb.group({
    stpOwnershipTypeId: [null],
    ministryName: ['']
  });

  stpOwnershipType: { id: number; name: string }[] = [
    { id: 1, name: 'Public' },
    { id: 2, name: 'Private' },
    { id: 3, name: 'NGO' },
    { id: 4, name: 'Others' },
  ];

  constructor(private fb: FormBuilder,
    private stpRegistrationStorageService: StpRegistrationStorageService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private notification: NzNotificationService,
    private nzMessageService: NzMessageService,
    private utilityService: UtilityService) { }

  ngOnInit(): void {
    this.getMinistryList();
  }



  getMinistryList()
  {
    this.ministryList.stpOwnershipType = this.searchingForm.value.stpOwnershipTypeId;
    this.ministryList.ministryName = this.searchingForm.value.ministryName;

    this.stpRegistrationStorageService.getMinistryList(this.ministryList).subscribe({
      next: (response: any) =>{

        this.listView = response.data;
        this.total = response.data?.totalElements;


        if(!response.success)
        {

          this.notification.error('Failed!', 'Unable to find any data!');
        }


      },
      error: (error: string) => this.notification.error('Failed', error),
    });
  }

  reset() {
    this.searchingForm.reset();
    this.getMinistryList();
  }

  onEdit(id: number): void {
    this.router.navigate(['/home/stp-registration/add-ministry/', id]);
  }

  onDelete(id?: number): void {
    this.stpRegistrationStorageService.deleteMinistry(id).subscribe({
      next: (response) => {
        if (response.success) {
          this.notification.success('Success!', response.message);
          this.getMinistryList();
        } else if (response.success == false) {
          this.notification.error('error!', response.message);
        }
      },

      error: (error) => this.notification.error('Failed', error),
    });
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    // console.log("Inside Query ", params);
    this.page = params.pageIndex;
    this.size = params.pageSize;

    params.sort.forEach((element: { value: string | null; key: string }) => {
      if (element.value != null) {
        this.sortingKey = element.key;
        this.sortingValue = element.value;
      }
    });

    if (this.sortingKey != null && this.sortingValue != null) {
      switch(this.sortingKey){
        case "ministryName":
         case "stpOwnershipTypeName" :
          this.stringTypeSorting(this.sortingKey, this.sortingValue);
          break;

      }

    }

    // this.getMinistryList();
  }

  stringTypeSorting(sortKey: string, sortVal: string) {




    this.listView.sort((a: any, b: any) => {
      let occupationA = a[sortKey];
      let occupationB = b[sortKey];

      if (sortVal == "ascend") {
        return occupationA.toLowerCase() > occupationB.toLowerCase() ? 1 : -1;
      } else {
        return occupationA.toLowerCase() < occupationB.toLowerCase() ? 1 : -1;
      }

    });



  }

}
